module.exports = {
	"config": {
		"siteTitle": "Aric Huang | Portfolio",
		"siteDescr": "「ジミな人」について",
		"siteAuthor": "Aric Huang",
		"siteGithubUrl": "http://github.com/concreted",
		"siteLinkedInUrl": "https://www.linkedin.com/in/arichuang1",
		"siteFacebookUrl": "https://www.facebook.com/aric.huangu",
		"siteYoutubeUrl": "https://www.youtube.com/user/concreteatelier/videos",
		"siteSoundcloudUrl": "https://soundcloud.com/aric-huang-1",
		"siteEmailUrl": "arichuang@gmail.com",
		"googleAnalyticsId": "",
		"linkPrefix": "/portfolio-lumen"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-27-hello-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-27-hello-world",
				"stem": "index",
				"path": "articles/2017-02-27-hello-world/index.md"
			},
			"requirePath": "articles/2017-02-27-hello-world/index.md",
			"path": "/hello-world/",
			"data": {
				"title": "Hello World",
				"date": "2017-02-27",
				"layout": "post",
				"path": "/hello-world/",
				"category": "MISC",
				"description": "Hello I have a new website"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/animation",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/animation",
				"stem": "index",
				"path": "pages/animation/index.md"
			},
			"requirePath": "pages/animation/index.md",
			"path": "/animation/",
			"data": {
				"title": "Animation",
				"layout": "page",
				"path": "/animation"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/art",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/art",
				"stem": "index",
				"path": "pages/art/index.md"
			},
			"requirePath": "pages/art/index.md",
			"path": "/art/",
			"data": {
				"title": "Art",
				"layout": "page",
				"path": "/art"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/code",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/code",
				"stem": "index",
				"path": "pages/code/index.md"
			},
			"requirePath": "pages/code/index.md",
			"path": "/code/",
			"data": {
				"title": "Code",
				"layout": "page",
				"path": "/code"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/comics",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/comics",
				"stem": "index",
				"path": "pages/comics/index.md"
			},
			"requirePath": "pages/comics/index.md",
			"path": "/comics/",
			"data": {
				"title": "Comics",
				"layout": "page",
				"path": "/comics"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/games",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/games",
				"stem": "index",
				"path": "pages/games/index.md"
			},
			"requirePath": "pages/games/index.md",
			"path": "/games/",
			"data": {
				"title": "Games",
				"layout": "page",
				"path": "/games"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/None",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/None",
				"stem": "index",
				"path": "pages/None/index.md"
			},
			"requirePath": "pages/None/index.md",
			"path": "/None/",
			"data": {
				"layout": "page",
				"path": "/None"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0